import { ElMessage, ElMessageBox } from 'element-plus';
import type { ProjectCreateDraftSnapshotV1 } from '@/utils/projectCreateWordSnapshot';

export const PROJECT_CREATE_LEAVE_CONFIRM_TITLE = '关闭创建项目';

export const PROJECT_CREATE_LEAVE_CONFIRM_MESSAGE =
  '是否保存当前新建项目的表单与对话快照为草稿？保存后将生成可 Word 打开的 HTML 快照，并可在「历史对话」中通过该会话回到本页继续编辑。';

/**
 * 是否存在用户实质编辑（忽略阶段计划默认值等自动填充）。
 * 无实质内容时关闭页签不应弹出「是否保存草稿」。
 */
export function projectCreateDraftHasUserEdits(snap: ProjectCreateDraftSnapshotV1 | null | undefined): boolean {
  if (!snap) return false;
  const f = snap.form;
  if ((f?.name || '').trim()) return true;
  if ((f?.projectCode || '').trim()) return true;
  if ((f?.owner || '').trim()) return true;
  if ((f?.description || '').trim()) return true;
  if ((f?.projectDeliveryDate || '').trim()) return true;
  if (f?.projectLeadUserId != null) return true;
  if ((f?.projectMemberUserIds?.length ?? 0) > 0) return true;
  if ((snap.messagesSnapshot?.length ?? 0) > 0) return true;
  if ((snap.aiProjectGoal || '').trim()) return true;
  if ((snap.aiProjectType || '').trim()) return true;
  if ((snap.aiProjectRisks?.length ?? 0) > 0) return true;
  if ((snap.aiSuggestedRiskLevel || '').trim()) return true;
  if (snap.aiStructuredResult && Object.keys(snap.aiStructuredResult).length > 0) return true;
  return false;
}

/**
 * 离开新建项目页时询问是否保存草稿。
 * @returns true 表示可以关闭页签；false 表示用户点了对话框关闭钮，应留在当前页。
 */
export async function confirmProjectCreateDraftLeave(args: {
  draftKey: string;
  persistDraftFull: (draftKey: string) => Promise<void>;
  removeDraftLocal: (draftKey: string) => void;
  /** 返回当前草稿快照；无实质编辑时直接丢弃并关闭，不弹确认框 */
  getDraftSnapshot?: (draftKey: string) => ProjectCreateDraftSnapshotV1 | null;
}): Promise<boolean> {
  const dk = String(args.draftKey || '').trim();
  if (!dk) return true;
  if (args.getDraftSnapshot && !projectCreateDraftHasUserEdits(args.getDraftSnapshot(dk))) {
    args.removeDraftLocal(dk);
    return true;
  }
  try {
    await ElMessageBox.confirm(PROJECT_CREATE_LEAVE_CONFIRM_MESSAGE, PROJECT_CREATE_LEAVE_CONFIRM_TITLE, {
      confirmButtonText: '保存草稿',
      cancelButtonText: '不保存',
      distinguishCancelAndClose: true,
      type: 'warning',
    });
    await args.persistDraftFull(dk);
    ElMessage.success('草稿已保存');
    return true;
  } catch (e) {
    if (e === 'close') return false;
    args.removeDraftLocal(dk);
    return true;
  }
}
